import { render, staticRenderFns } from "./GetPictureFromCameraPwaBtn.vue?vue&type=template&id=956156dc&scoped=true&"
import script from "./GetPictureFromCameraPwaBtn.vue?vue&type=script&lang=js&"
export * from "./GetPictureFromCameraPwaBtn.vue?vue&type=script&lang=js&"
import style0 from "./GetPictureFromCameraPwaBtn.vue?vue&type=style&index=0&id=956156dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956156dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('956156dc')) {
      api.createRecord('956156dc', component.options)
    } else {
      api.reload('956156dc', component.options)
    }
    module.hot.accept("./GetPictureFromCameraPwaBtn.vue?vue&type=template&id=956156dc&scoped=true&", function () {
      api.rerender('956156dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/Captures/components/GetPictureFromCameraPwaBtn.vue"
export default component.exports